import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { HakMenuLevel } from '@/types';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface AuthUser {
    id?: number;
    name?: string;
    email?: string;
    role?: string;
    level?: string;
    user_name?: string;
    user_kode?: string;
    [key: string]: unknown;
}

interface AuthState {
    accessToken: string | null;
    user: AuthUser | null;
    /** Hak level user login per menu (GET /setting/level/<level sendiri>) — dibaca usePermission / Sidebar. */
    permissions: HakMenuLevel[] | null;
    /** NmMMenu menu yang TERBUKA untuk user login (GET /menu: IsShow = 1, fitur aktif, hak level — model Delphi). */
    visibleMenus: string[] | null;
    /** Judul tampil menu yang berbeda dari NmMMenu (GET /menu field Caption; mis. menu Serial Number mengikuti label) */
    menuCaptions: Record<string, string>;
    setLogin: (data: { token: string; user: AuthUser }) => void;
    setPermissions: (permissions: HakMenuLevel[]) => void;
    setVisibleMenus: (menus: string[]) => void;
    setMenuCaptions: (captions: Record<string, string>) => void;
    logout: () => void;
    isAuthenticated: () => boolean;
}

// ─── Store ────────────────────────────────────────────────────────────────────

const useAuthStore = create<AuthState>()(
    persist(
        (set) => ({
            accessToken: null,
            user: null,
            permissions: null,
            visibleMenus: null,
            menuCaptions: {},

            setLogin: (data) => set({
                accessToken: data.token,
                user: data.user
            }),

            setPermissions: (permissions) => set({ permissions }),

            setVisibleMenus: (visibleMenus) => set({ visibleMenus }),

            setMenuCaptions: (menuCaptions) => set({ menuCaptions }),

            logout: () => {
                set({ accessToken: null, user: null, permissions: null, visibleMenus: null, menuCaptions: {} });
                window.location.href = '/login';
            },

            isAuthenticated: () => !!useAuthStore.getState().accessToken,
        }),
        {
            name: 'auth-storage',
        }
    )
);

export default useAuthStore;
